/* eslint-disable no-restricted-syntax */
import React, {Fragment, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {addHoliday, editHoliday, getHoliday, deleteHoliday} from 'helpers/api';
import {Grid, Button, Card, TextField} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import ReplayIcon from '@material-ui/icons/Replay';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import moment from 'moment';

import {MuiPickersUtilsProvider, DatePicker} from '@material-ui/pickers';

import MomentUtils from '@date-io/moment';
import {Page} from 'store/reducers/Page/pageAction';
import Error from '../../Error';
import Delete from '../../ButtonDelete/index';

export default function Formulario(props) {
  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();
  const history = useHistory();

  const [holiday, setHoliday] = useState('');
  const [result, setResult] = useState({});
  const [disable, setDisable] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  moment.locale(i18n.language);

  useEffect(() => {
    setMaxDate(
      new Date(
        `${maxDate.getFullYear() + 2}-${
          maxDate.getMonth() + 1
        }-${maxDate.getDate()} 01:00:00`,
      ),
    );

    dispatch(Page(t('word.holiday')));
    if (props.id) {
      const getOne = async (id) => {
        const res = await getHoliday(id);
        if (res.errors) {
          for (const i of res.errors) {
            props.openAlert(
              t(`message.${i.code}`, {param: t(`word.${i.field}`)}),
              i.color,
            );
          }
          history.replace('/holiday');
        } else {
          setHoliday(res.holiday);
          setSelectedDate(new Date(`${res.date} 01:00:00`));
        }
      };
      getOne(props.id);
    }
    // eslint-disable-next-line
  }, []);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisable(true);
    const date = moment(selectedDate).format(t('format.date'));
    let res;
    let formatDate;

    if (t('format.date') === 'DD/MM/YYYY') {
      formatDate = date.split('/').reverse().join('-');
      formatDate = moment(formatDate).format('YYYY-MM-DD');
    } else {
      formatDate = moment(date).format('YYYY-MM-DD');
    }

    if (props.id) {
      res = await editHoliday(props.id, holiday, formatDate);
      setResult(res);
    } else {
      res = await addHoliday(holiday, formatDate);
      setResult(res);
    }

    if (res && !res.errors) {
      if (props.id) {
        props.openAlert(
          t('message.edit-record', {param: t('word.holiday')}),
          'success',
        );
      } else {
        props.openAlert(
          t('message.insert-record', {param: t('word.holiday')}),
          'success',
        );
      }
      history.replace('/holiday');
    } else {
      setDisable(false);
    }
  };

  const delHoliday = async (id) => {
    const res = await deleteHoliday(id);
    setResult(res);
    if (res && !res.errors) {
      props.openAlert(
        t('message.delete-record', {param: t('word.holiday')}),
        'success',
      );
      history.replace('/holiday');
    }
  };

  return (
    <>
      <Card className="p-4 mb-4">
        {result.errors && <Error result={result} />}
        <form onSubmit={handleSubmit}>
          <Grid container direction="row" spacing={12}>
            <Grid container xs={12} md={9} sm={9}>
              <TextField
                className="m-2"
                label={t('word.holiday')}
                id="standard-size-small"
                size="small"
                required
                disabled={disable}
                value={holiday}
                onChange={(e) => setHoliday(e.target.value)}
                inputProps={{maxLength: 128}}
                fullWidth
              />
            </Grid>
            <Grid container xs={12} sm={3} style={{marginTop: '-2.2px'}}>
              <MuiPickersUtilsProvider
                libInstance={moment}
                locale={i18n.language}
                utils={MomentUtils}>
                <DatePicker
                  disableToolbar
                  className="m-2"
                  variant="inline"
                  format={t('format.date-material')}
                  margin="normal"
                  id="date-picker-inline"
                  label={t('word.date')}
                  value={selectedDate}
                  onChange={handleDateChange}
                  fullWidth
                  maxDate={maxDate}
                />
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
          <div style={{float: 'right'}}>
            <Button
              style={{textTransform: 'none'}}
              disabled={disable}
              onClick={() => history.replace('/holiday')}
              className="m-2"
              variant="contained"
              color="secondary">
              <ReplayIcon />
              {t('word.cancel')}
            </Button>

            <Delete func={delHoliday} id={props.id} disabled={disable} />

            <Button
              style={{textTransform: 'none'}}
              disabled={disable}
              type="submit"
              className="m-2"
              color="secondary"
              variant="contained">
              <CheckIcon />
              {t('word.save')}
            </Button>
          </div>
        </form>
      </Card>
    </>
  );
}
